// Ekran 10 — Kontrol Paneli API istemcisi.
//
// Panelin TÜM sayıları sunucudan geliyor; ekranda hesap yok (bkz.
// docs/kararlar-ek.md — referans mockup'ta hepsi HTML'e gömülüydü).

import { api } from '../../lib/api'

export type IsikDurumu = 'ok' | 'warn' | 'crit'
export type BeyanDurumu = 'taslak' | 'onayli'

export type PanelIsigi = {
  anahtar: string
  durum: IsikDurumu
  baslik: string
  alt: string
  modul: string
  rota: string
}

export type Delta = {
  yuzde: number | null
  /** up · dn · nt — .dlt sınıfı. */
  yon: string
  etiket: string
}

export type KpiKutusu = {
  etiket: string
  deger: number | null
  basamak: number
  birim: string | null
  bant: string | null
  delta: Delta | null
  altMetin: string
  /** Değer işaretiyle okunuyor mu (K29 dengesizliği ±)? */
  isaretli: boolean
}

export type PanelKpi = {
  anlikGuc: KpiKutusu
  spark: (number | null)[]
  uretim: KpiKutusu
  biyogaz: KpiKutusu
  besleme: KpiKutusu
  dengesizlik: KpiKutusu
}

export type CurutucuKarti = {
  uniteId: string
  kod: string
  ad: string
  isik: IsikDurumu
  gaz: number | null
  delta: Delta | null
  beslemeT: number | null
  sicaklik: number | null
  doluluk: number | null
}

export type GrafikSerisi = {
  anahtar: string
  etiket: string
  etiketler: string[]
  uretim: (number | null)[]
  satis: (number | null)[]
  ic: (number | null)[]
  /** Biyogaz Nm³ — grafiğin yeşil çizgisi. */
  gaz: (number | null)[]
  /** K29 — sunucuda hesaplandı; ekran yalnız çiziyor. */
  dengesizlik: (number | null)[]
  dengesizlikBant: (string | null)[]
  not: string
}

export type PanelGrafigi = { saat: GrafikSerisi; gun: GrafikSerisi; ay: GrafikSerisi }

export type SonKayitSatiri = {
  etiket: string
  deger: number | null
  basamak: number
  birim: string | null
  not: string | null
  bant: string | null
}

export type SonKayit = {
  veriSaati: string
  gaz: SonKayitSatiri[]
  uretim: SonKayitSatiri[]
  dengesizlik: number | null
  taahhutSapmasi: number | null
}

export type BantSegmenti = { bas: number; son: number; bant: string }

export type PanelBandi = {
  gosterge: string
  etiket: string
  deger: number | null
  bant: string | null
  hedef: string
  degerMetni: string
  /** Bandın uç değerleri — işaretçi konumu bunlara göre oranlanıyor. */
  min: number
  maks: number
  /** Renkli dilimler; sınırlar ayar_esik'ten (§8-14). */
  segmentler: BantSegmenti[]
}

export type PanelUyarisi = {
  sev: string
  baslik: string
  metin: string
  /** Kural referansı metnin içinde geçiyor; burası yalnız rota/anahtar için. */
  kuralRef: string
  rota: string | null
  /** Başlığın yanındaki `.cell-sub` — saat yoksa hiç basılmaz (ref:648). */
  saat: string | null
}

export type KritikStokSatiri = {
  stokKartiId: string
  kod: string
  ad: string
  bakiye: number | null
  kritik: number | null
  birim: string
  durum: string
}

export type FeedSatiri = {
  id: string
  zaman: string
  belgeNo: string
  belgeTip: string
  aciklama: string
  stornoEdildi: boolean
}

export type KumulatifKart = {
  baslik: string
  uretimKwh: number | null
  biyogazNm3: number | null
  beslemeT: number | null
  kapasiteFaktoru: number | null
}

export type GunKapanisi = {
  acikIsik: number
  adlar: string[]
  kapatilabilir: boolean
  mesaj: string
}

export type PanelOzeti = {
  tarih: string
  sinirSaat: number
  sonDoluSaat: number | null
  panelZamani: string
  beyanDurumu: BeyanDurumu
  isiklar: PanelIsigi[]
  kpi: PanelKpi
  adrow: CurutucuKarti[]
  grafik: PanelGrafigi
  sonKayit: SonKayit
  kumulatif: { ay: KumulatifKart; yil: KumulatifKart }
  bantlar: PanelBandi[]
  uyarilar: PanelUyarisi[]
  kritikStok: KritikStokSatiri[]
  feed: FeedSatiri[]
  kapanis: GunKapanisi
}

export const panel = {
  ozet: (tarih?: string) => api<PanelOzeti>(`/api/panel/ozet${tarih ? `?tarih=${tarih}` : ''}`),
}
